import { render } from "./template-editor.vue?vue&type=template&id=1f55017c&scoped=true"
import script from "./template-editor.vue?vue&type=script&lang=js"
export * from "./template-editor.vue?vue&type=script&lang=js"

import "./template-editor.vue?vue&type=style&index=0&id=1f55017c&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f55017c"]])

export default __exports__